import { CONTACT } from "../lib/data";
import { trackContact } from "../lib/fb";

export const Footer = () => (
  <footer data-testid="footer" className="bg-[#0E0E0E] text-[#F4F4F0]">
    <div className="flex h-1.5" aria-hidden="true">
      <span className="flex-1 bg-[#00AEEF]" />
      <span className="flex-1 bg-[#EC008C]" />
      <span className="flex-1 bg-[#FFD200]" />
      <span className="flex-1 bg-[#FF3B30]" />
    </div>
    <div className="px-6 md:px-12 lg:px-24 pt-20 pb-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-10 font-mono text-xs leading-relaxed pb-16 border-b border-[#F4F4F0]/20">
        <div data-testid="footer-address">
          <p className="uppercase tracking-[0.25em] text-[#F4F4F0]/50 mb-3">Visit the press</p>
          <p className="text-[#F4F4F0]/80">{CONTACT.address}</p>
        </div>
        <div data-testid="footer-contact">
          <p className="uppercase tracking-[0.25em] text-[#F4F4F0]/50 mb-3">Talk to us</p>
          <a href={CONTACT.whatsappHref} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" onClick={trackContact} className="inline-flex items-center gap-2 text-[#25D366] hover:text-[#F4F4F0] transition-colors duration-200 mb-2">
            WhatsApp {CONTACT.whatsapp} →
          </a>
          <a href={`mailto:${CONTACT.email}`} className="block hover:text-[#FF3B30] transition-colors duration-200">{CONTACT.email}</a>
        </div>
        <div>
          <p className="uppercase tracking-[0.25em] text-[#F4F4F0]/50 mb-3">Hours</p>
          <p className="text-[#F4F4F0]/80">Mon – Sat / 10:00 – 19:00 IST</p>
          <p className="text-[#F4F4F0]/80">Press runs on schedule.</p>
        </div>
      </div>
      <div className="pt-12 overflow-hidden">
        <p className="font-display font-bold uppercase tracking-tighter leading-none text-[11vw] text-[#F4F4F0]/90 whitespace-nowrap" data-testid="footer-brand-text">
          Siddharth Offsets<span className="text-[#FF3B30]">.</span>
        </p>
      </div>
      <div className="flex flex-col md:flex-row justify-between gap-2 font-mono text-[10px] uppercase tracking-widest text-[#F4F4F0]/40 mt-8">
        <span>© {new Date().getFullYear()} Siddharth Offsets, Indore</span>
        <a href="/privacy-policy" data-testid="footer-privacy-link" className="hover:text-[#FF3B30] transition-colors duration-200 underline underline-offset-4">Privacy Policy</a>
        <span><span style={{color:"#00AEEF"}}>C</span><span style={{color:"#EC008C"}}>M</span><span style={{color:"#FFD200"}}>Y</span>K / Offset / Since day one</span>
      </div>
    </div>
  </footer>
);
